const GEOMETRIS_PAIRED_MESSAGE =
    "Geometris camera selected. The ELD hardware is set to Geometris, and the device serial number now matches the camera's serial number. Changes to ELD are not allowed.";
const GEOMETRIS_REQUIRES_ELD_MESSAGE =
    'When the camera type is set to Geometris, the Device Type must be "ELD" and the Hardware must be "Prime8 Connect". These fields cannot be changed while Geometris camera is selected.';

export { GEOMETRIS_PAIRED_MESSAGE, GEOMETRIS_REQUIRES_ELD_MESSAGE };